var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.0027 38.7856L42.233 0L0.464859 38.7856C-0.123508 39.3332 -0.15846 40.255 0.389129 40.8449C0.933804 41.4332 1.85859 41.4667 2.44695 40.9206L7.28059 36.4321V85H30.5822H53.8839H77.1855V36.4306L82.0191 40.9191C82.2987 41.1798 82.6556 41.308 83.0109 41.308C83.4027 41.308 83.7915 41.1521 84.077 40.8434C84.626 40.255 84.591 39.3332 84.0027 38.7856ZM33.4949 82.0873V58.7857C33.4949 53.9666 37.414 50.0475 42.233 50.0475C47.0521 50.0475 50.9711 53.9666 50.9711 58.7857V82.0873H33.4949ZM74.2728 82.0873H53.8839V58.7857C53.8839 52.3617 48.657 47.1348 42.233 47.1348C35.8091 47.1348 30.5822 52.3617 30.5822 58.7857V82.0873H10.1933V33.7262L42.233 3.97439L74.2728 33.7262V82.0873Z",
    fill: "#25A18E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.175f25be993ef4cf955d0756332b7b63.svg";
export { ForwardRef as ReactComponent };